import React from 'react';
import { LockIcon } from '../components/icons/lock-icon';
import { useTranslate } from '../context/api-context/translations/use-translate';
import { st, classes } from './commenting-locked-empty-state.st.css';
const CommentingLockedEmptyState = ({ className, isMobile, }) => {
    const t = useTranslate();
    return (React.createElement("div", { className: st(classes.root, { isMobile }, className) },
        React.createElement(LockIcon, { className: classes.icon }),
        React.createElement("span", { className: classes.text }, t('empty-state.commenting-locked-text'))));
};
export default CommentingLockedEmptyState;
//# sourceMappingURL=commenting-locked-empty-state.js.map